import {obtenerFechaEstandarCheckIn} from "./obtenerFechaEstandarCheckIn";
import {obtenerFechaEstandarCheckOut} from "./obtenerFechaEstandarCheckOut";
import {adaptadorReservaHabitacionVista} from "../Adaptadores/adaptadorReservaHabitacionVista";
import {FECHACHECKIN, FECHACHECKOUT} from "../Constantes";
//import {adaptadorReservaHabitacionVista} from "../Adaptadores/adaptadorReservaHabitacionVista";

export const poblarReservacionesVista = ({reservaciones, arrHabitaciones, fechaEscogida}) => {

    let arr = []
    let fecha = obtenerFechaEstandarCheckIn(fechaEscogida)
    let fechaEgresoHoy = obtenerFechaEstandarCheckOut(new Date().getTime())


    for (let i = 0; i < arrHabitaciones.length; i++) {
        let habitacion = arrHabitaciones[i]
        let index = reservaciones.findIndex((e) => e.idHabitacion === habitacion.id)


        if (index > -1 &&
            (
                reservaciones[index][FECHACHECKIN] === fecha ||
                (reservaciones[index][FECHACHECKOUT] >= fecha && reservaciones[index][FECHACHECKIN] <= fecha) ||
                reservaciones[index][FECHACHECKOUT] === fechaEgresoHoy

            )

        ) {
          arr.push(adaptadorReservaHabitacionVista({
                reserva: reservaciones[index],
                habitacion: habitacion,
                fechaEscogida: fechaEscogida
            }))
           //  arr.push(reservaciones[index])
        } else {
            arr.push(habitacion)
        }

    }



    return arr

}

